import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { InputKit } from '../../../components/UI';
import { AuthService } from '../../../Service/AuthService';
import { LocalStorageService } from '../../../Service/LocalStorageService';
import { useAppDispatch } from '../../../store/hooks';
import { setAuthUser, setToken } from '../../../store/user/user-slice';
import { zodResolver } from '@hookform/resolvers/zod';
import { schema } from './validations';
import { createNotification } from '../../../store/notifications/notification-slice';
export interface IFormInput {
  email: string;
  password: string;
}

const Login = () => {
  const appDispatch = useAppDispatch();
  const methods = useForm<IFormInput>({ resolver: zodResolver(schema) });
  const { handleSubmit, setError } = methods;

  const navigate = useNavigate();

  const loginUser = async (values: IFormInput) => {
    try {
      const response = await AuthService.login(values.email, values.password);

      LocalStorageService.setItem('accessToken', response.data.accessToken);
      LocalStorageService.setItem('role', response.data.role);

      appDispatch(setToken(response.data.accessToken));
      appDispatch(setAuthUser(response.data));

      navigate('/home');
    } catch (error: any) {
      if (
        error.message === 'Password is incorrect!' &&
        error.statusCode === 401
      ) {
        setError('password', {
          type: 'required',
          message: 'Password is incorrect!',
        });
      } else if (
        error.message === 'Email does not exist!' &&
        error.statusCode === 401
      ) {
        setError('email', {
          type: 'required',
          message: 'Email does not exist!',
        });
      } else {
        appDispatch(
          createNotification({ type: 'error', message: error.message })
        );
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          maxWidth: '100%',
          width: '100%',
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <form
          action='submit'
          style={{
            maxWidth: '472px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
          }}
          onSubmit={handleSubmit(loginUser)}
        >
          <Typography variant='h1'>Log in</Typography>
          <InputKit name={'email'} placeholder={'Email'} type='email' />
          <InputKit
            name='password'
            type='password'
            placeholder='Password'
            sxStyle={{
              width: '100%',
            }}
          />
          <Link
            style={{
              textDecoration: 'none',
              color: '#3293DB',
              marginTop: '-18px',
              textAlign: 'right',
            }}
            to='/forgot-password'
          >
            Forgot password?
          </Link>

          <Button
            sx={{
              background: '#3293DB',
              color: '#fff',
              maxWidth: '100%',
              boxShadow: 'unset',
              fontSize: '14px',
              lineHeight: '17px',
            }}
            type='submit'
            variant='contained'
          >
            Log In
          </Button>
          <Button
            sx={{
              maxWidth: '100%',
              boxShadow: 'unset',
              fontSize: '14px',
              lineHeight: '17px',
            }}
            onClick={() => navigate('/register/request')}
            variant='outlined'
          >
            Register
          </Button>
        </form>
      </Box>
    </FormProvider>
  );
};

export default Login;
